import React from "react";
import {observer} from "mobx-react-lite";
import {stores} from "../stores";
import "./Tabs.css";

export const Tabs = observer(() => {

    return (
        <div className="tabs">
            <div className="tab padding-left">
                &nbsp;&nbsp;
            </div>
            <div className={`tab ${stores.state.activeTab === 'single' ? 'active' : 'inactive'}`} onClick={() => stores.state.setTab("single")}>
                <div className="tab-name">
                    One preset
                </div>
            </div>
            <div className="tab padding-middle">
                &nbsp;&nbsp;
            </div>
            <div className={`tab ${stores.state.activeTab === 'all' ? 'active' : 'inactive'}`} onClick={() => stores.state.setTab("all")}>
                <div className="tab-name">
                    All Presets
                </div>
            </div>
            <div className="tab padding-middle">
                &nbsp;&nbsp;
            </div>
            <div className={`tab ${stores.state.activeTab === 'utils' ? 'active' : 'inactive'}`} onClick={() => stores.state.setTab("utils")}>
                <div className="tab-name">
                    Utils X &amp; Y
                </div>
            </div>
            <div className="tab padding-middle">
                &nbsp;&nbsp;
            </div>
            <div className={`tab ${stores.state.activeTab === 'help' ? 'active' : 'inactive'}`} onClick={() => stores.state.setTab("help")}>
                <div className="tab-name">
                    Help
                </div>
            </div>
            <div className="tab padding">
                &nbsp;&nbsp;
            </div>
        </div>
    );

});
